import { RefObject, createRef, useEffect, useMemo, useRef } from "react"

import { Overlay } from "shared/context/overlay/types"

export function useOverlaysWithRefs(overlays: Overlay[]) {
  const refs = useRef<Record<string, RefObject<HTMLDivElement | null>>>({})
  useEffect(() => {
    refs.current = Object.fromEntries(
      Object.entries(refs.current).filter(([key]) =>
        overlays.some(overlay => overlay.id === key)
      )
    )
  }, [overlays])

  const overlaysWithRefs = useMemo(
    () =>
      overlays.map(overlay => {
        if (!refs.current[overlay.id]) {
          refs.current[overlay.id] = createRef()
        }

        return { overlay, ref: refs.current[overlay.id] }
      }),
    [overlays]
  )

  return overlaysWithRefs
}
